import {
  GoogleRMKT,
  GoogleSiteTag,
  GoogleAds
} from "@/pixels/providers/google";
import { packageCode } from "@/config/constants/packagesCodes";

describe("GoogleRMKT config", () => {
  beforeEach(() => {
    jest.spyOn(GoogleRMKT, "enable");
    jest.spyOn(GoogleRMKT, "init");
    jest.spyOn(GoogleRMKT, "wait");
    jest.spyOn(GoogleRMKT, "enviar");
    jest.spyOn(GoogleRMKT, "landing");
    jest.spyOn(GoogleRMKT, "oferta");
    jest.spyOn(GoogleRMKT, "ofertaCA");
    jest.spyOn(GoogleRMKT, "sucursal");
    jest.spyOn(GoogleRMKT, "paso1");
    jest.spyOn(GoogleRMKT, "paso2");
    jest.spyOn(GoogleRMKT, "paso3");
    jest.spyOn(GoogleRMKT, "paso4");
    jest.spyOn(GoogleRMKT, "thankYou");
    jest.spyOn(GoogleRMKT, "thankYouCA");
    jest.spyOn(GoogleRMKT, "cliente");
    jest.spyOn(GoogleRMKT, "noCliente");

    window.google_trackConversion = jest.fn();
  });

  it("configuracion GoogleRMKT por defecto", () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {}
        }
      }
    };

    GoogleRMKT.enable();
    GoogleRMKT.wait();
    GoogleRMKT.init();
    GoogleRMKT.enviar();
    GoogleRMKT.landing();
    GoogleRMKT.oferta(context);
    GoogleRMKT.ofertaCA();
    GoogleRMKT.sucursal();
    GoogleRMKT.paso1(context);
    GoogleRMKT.paso2(context);
    GoogleRMKT.paso3(context);
    GoogleRMKT.paso4(context);
    GoogleRMKT.thankYou(context);
    GoogleRMKT.thankYouCA();
    GoogleRMKT.cliente();
    GoogleRMKT.noCliente();

    const enableMock = jest.spyOn(GoogleRMKT, "enable");
    const waitMock = jest.spyOn(GoogleRMKT, "wait");
    const initMock = jest.spyOn(GoogleRMKT, "init");
    const enviarMock = jest.spyOn(GoogleRMKT, "enviar");
    const landingMock = jest.spyOn(GoogleRMKT, "landing");
    const ofertaMock = jest.spyOn(GoogleRMKT, "oferta");
    const ofertaCAMock = jest.spyOn(GoogleRMKT, "ofertaCA");
    const sucursalMock = jest.spyOn(GoogleRMKT, "sucursal");
    const paso1Mock = jest.spyOn(GoogleRMKT, "paso1");
    const paso2Mock = jest.spyOn(GoogleRMKT, "paso2");
    const paso3Mock = jest.spyOn(GoogleRMKT, "paso3");
    const paso4Mock = jest.spyOn(GoogleRMKT, "paso4");
    const thankYouMock = jest.spyOn(GoogleRMKT, "thankYou");
    const thankYouCAMock = jest.spyOn(GoogleRMKT, "thankYouCA");
    const clienteMock = jest.spyOn(GoogleRMKT, "cliente");
    const noClienteMock = jest.spyOn(GoogleRMKT, "noCliente");

    expect(enableMock).toHaveBeenCalledTimes(1);
    expect(waitMock).toHaveBeenCalledTimes(1);
    expect(initMock).toHaveBeenCalledTimes(1);
    expect(enviarMock).toHaveBeenCalledTimes(1);
    expect(landingMock).toHaveBeenCalledTimes(1);
    expect(ofertaMock).toHaveBeenCalledTimes(1);
    expect(ofertaCAMock).toHaveBeenCalledTimes(1);
    expect(sucursalMock).toHaveBeenCalledTimes(1);
    expect(paso1Mock).toHaveBeenCalledTimes(1);
    expect(paso2Mock).toHaveBeenCalledTimes(1);
    expect(paso3Mock).toHaveBeenCalledTimes(1);
    expect(paso4Mock).toHaveBeenCalledTimes(1);
    expect(thankYouMock).toHaveBeenCalledTimes(1);
    expect(thankYouCAMock).toHaveBeenCalledTimes(1);
    expect(clienteMock).toHaveBeenCalledTimes(1);
    expect(noClienteMock).toHaveBeenCalledTimes(1);
  });

  it("configuracion exportada por defecto", () => {
    expect(GoogleRMKT).toBeDefined();
    expect(GoogleRMKT).not.toBeNull();
    expect(typeof GoogleRMKT).toBe("object");
  });
});

describe("GoogleSiteTag config", () => {
  beforeEach(() => {
    jest.spyOn(GoogleSiteTag, "enable");
    jest.spyOn(GoogleSiteTag, "wait");
    jest.spyOn(GoogleSiteTag, "landing");
    jest.spyOn(GoogleSiteTag, "snippetOferta");
    jest.spyOn(GoogleSiteTag, "snippetSucursal");
    jest.spyOn(GoogleSiteTag, "snippetPaso1");
    jest.spyOn(GoogleSiteTag, "snippetPaso2");
    jest.spyOn(GoogleSiteTag, "snippetPaso3");
    jest.spyOn(GoogleSiteTag, "snippetPaso4");
    jest.spyOn(GoogleSiteTag, "snippetThank");
    jest.spyOn(GoogleSiteTag, "snippetCliente");
    jest.spyOn(GoogleSiteTag, "snippetNoCliente");
    jest.spyOn(GoogleSiteTag, "snippetGraciasCajaAhorro");

    window.gtag = jest.fn();
  });

  it("configuracion GoogleSiteTag por defecto", () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: ""
          }
        }
      }
    };

    GoogleSiteTag.enable();
    GoogleSiteTag.wait();
    GoogleSiteTag.landing();
    GoogleSiteTag.snippetOferta();
    GoogleSiteTag.snippetSucursal();
    GoogleSiteTag.snippetPaso1();
    GoogleSiteTag.snippetPaso2();
    GoogleSiteTag.snippetPaso3();
    GoogleSiteTag.snippetPaso4();
    GoogleSiteTag.snippetThank(context);
    GoogleSiteTag.snippetCliente();
    GoogleSiteTag.snippetNoCliente();
    GoogleSiteTag.snippetGraciasCajaAhorro();

    const enableMock = jest.spyOn(GoogleSiteTag, "enable");
    const waitMock = jest.spyOn(GoogleSiteTag, "wait");
    const landingMock = jest.spyOn(GoogleSiteTag, "landing");
    const snippetOfertaMock = jest.spyOn(GoogleSiteTag, "snippetOferta");
    const snippetSucursalMock = jest.spyOn(GoogleSiteTag, "snippetSucursal");
    const snippetPaso1Mock = jest.spyOn(GoogleSiteTag, "snippetPaso1");
    const snippetPaso2Mock = jest.spyOn(GoogleSiteTag, "snippetPaso2");
    const snippetPaso3Mock = jest.spyOn(GoogleSiteTag, "snippetPaso3");
    const snippetPaso4Mock = jest.spyOn(GoogleSiteTag, "snippetPaso4");
    const snippetThankMock = jest.spyOn(GoogleSiteTag, "snippetThank");
    const snippetClienteMock = jest.spyOn(GoogleSiteTag, "snippetCliente");
    const snippetNoClienteMock = jest.spyOn(GoogleSiteTag, "snippetNoCliente");
    const snippetGraciasCajaAhorroMock = jest.spyOn(
      GoogleSiteTag,
      "snippetGraciasCajaAhorro"
    );

    expect(enableMock).toHaveBeenCalledTimes(1);
    expect(waitMock).toHaveBeenCalledTimes(1);
    expect(landingMock).toHaveBeenCalledTimes(1);
    expect(snippetOfertaMock).toHaveBeenCalledTimes(1);
    expect(snippetSucursalMock).toHaveBeenCalledTimes(1);
    expect(snippetPaso1Mock).toHaveBeenCalledTimes(1);
    expect(snippetPaso2Mock).toHaveBeenCalledTimes(1);
    expect(snippetPaso3Mock).toHaveBeenCalledTimes(1);
    expect(snippetPaso4Mock).toHaveBeenCalledTimes(1);
    expect(snippetThankMock).toHaveBeenCalledTimes(1);
    expect(snippetClienteMock).toHaveBeenCalledTimes(1);
    expect(snippetNoClienteMock).toHaveBeenCalledTimes(1);
    expect(snippetGraciasCajaAhorroMock).toHaveBeenCalledTimes(1);
  });

  it("configuracion GoogleSiteTag SnippetThank LIBRETON_EXPRESS", () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: packageCode.LIBRETON_EXPRESS
          }
        }
      }
    };
    GoogleSiteTag.snippetThank(context);
    const snippetThankMock = jest.spyOn(GoogleSiteTag, "snippetThank");
    expect(snippetThankMock).toHaveBeenCalled();
  });

  it("configuracion GoogleSiteTag SnippetThank LIBRETON_FULL", () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: packageCode.LIBRETON_FULL
          }
        }
      }
    };
    GoogleSiteTag.snippetThank(context);
    const snippetThankMock = jest.spyOn(GoogleSiteTag, "snippetThank");
    expect(snippetThankMock).toHaveBeenCalled();
  });

  it("configuracion GoogleSiteTag SnippetThank LIBRETON_PLUS_GOLD", () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: packageCode.LIBRETON_PLUS_GOLD
          }
        }
      }
    };
    GoogleSiteTag.snippetThank(context);
    const snippetThankMock = jest.spyOn(GoogleSiteTag, "snippetThank");
    expect(snippetThankMock).toHaveBeenCalled();
  });

  it("configuracion GoogleSiteTag SnippetThank LIBRETON_PREMIUM", () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: packageCode.LIBRETON_PREMIUM
          }
        }
      }
    };
    GoogleSiteTag.snippetThank(context);
    const snippetThankMock = jest.spyOn(GoogleSiteTag, "snippetThank");
    expect(snippetThankMock).toHaveBeenCalled();
  });

  it("configuracion GoogleSiteTag SnippetThank LIBRETON_PREMIUM_WORLD", () => {
    const context = {
      state: {
        paquetesBeneficios: {
          caracteristicas: {
            tipoPaquete: packageCode.LIBRETON_PREMIUM_WORLD
          }
        }
      }
    };
    GoogleSiteTag.snippetThank(context);
    const snippetThankMock = jest.spyOn(GoogleSiteTag, "snippetThank");
    expect(snippetThankMock).toHaveBeenCalled();
  });

  it("configuracion exportada por defecto", () => {
    expect(GoogleSiteTag).toBeDefined();
    expect(GoogleSiteTag).not.toBeNull();
    expect(typeof GoogleSiteTag).toBe("object");
  });
});

describe("GoogleAds config", () => {
  beforeEach(() => {
    jest.spyOn(GoogleAds, "enable");
    jest.spyOn(GoogleAds, "init");
    jest.spyOn(GoogleAds, "wait");
    jest.spyOn(GoogleAds, "graciasCajaAhorro");

    window.gtag = jest.fn();
  });

  it("configuracion GoogleAds por defecto", () => {
    GoogleAds.enable();
    GoogleAds.wait();
    GoogleAds.init();
    GoogleAds.graciasCajaAhorro();

    const enableMock = jest.spyOn(GoogleAds, "enable");
    const waitMock = jest.spyOn(GoogleAds, "wait");
    const initMock = jest.spyOn(GoogleAds, "init");
    const graciasCajaAhorroMock = jest.spyOn(GoogleAds, "graciasCajaAhorro");

    expect(enableMock).toHaveBeenCalledTimes(1);
    expect(waitMock).toHaveBeenCalledTimes(1);
    expect(initMock).toHaveBeenCalledTimes(1);
    expect(graciasCajaAhorroMock).toHaveBeenCalledTimes(1);
  });

  it("configuracion exportada por defecto", () => {
    expect(GoogleAds).toBeDefined();
    expect(GoogleAds).not.toBeNull();
    expect(typeof GoogleAds).toBe("object");
  });
});
